/* Doodhvale collection page behaviour (sections/dvf-collection.liquid). No dependencies.
   Everything works without this file; it only makes things nicer:
   - design filters (Filter group blocks) filter the cards in the page instantly and live in the
     URL; Filter button opens the panel on phones; Shopify filters apply on change on desktop;
     sort applies on change everywhere and keeps the design filters.
   Ported from the buy store's assets/dvf-ui.js (collection parts only). */
(function () {
  'use strict';
  if (window.DVFPlp) return;

  var DESKTOP = '(min-width: 1000px)';
  var isDesktop = function () { return window.matchMedia(DESKTOP).matches; };

  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.matches) return;
    if (t.matches('[data-dvf-cfilter]')) onFilterBox(t);
    else if (t.matches('[data-dvf-autosubmit]')) onAutoSubmit(t);
  });

  // ------------------------------------------------------------------ design filters (in the page)
  // Every card <li> carries data-f-<key>="v1|v2" (sections/dvf-collection.liquid). The state is
  // { key: [values] }: OR inside a key, AND across keys, mirrored in the URL (?milk=Buffalo&size=s1).

  function filterKeys(plp) {
    // No in-page filters on this page (e.g. a multi-page collection uses Shopify's): nothing to do.
    if (!plp.querySelector('[data-dvf-cfilters], [data-dvf-chip-query]')) return [];
    var li = plp.querySelector('[data-dvf-grid] > li:not([data-dvf-story])');
    if (!li) return [];
    return Array.prototype.filter.call(li.attributes, function (a) { return a.name.indexOf('data-f-') === 0; })
      .map(function (a) { return a.name.slice(7); });
  }

  function stateFromQuery(plp, query) {
    var params = new URLSearchParams(query || '');
    var st = {};
    filterKeys(plp).forEach(function (k) {
      var vals = params.getAll(k).filter(Boolean);
      if (vals.length) st[k] = vals;
    });
    return st;
  }

  function sameState(a, b) {
    var ka = Object.keys(a).sort(), kb = Object.keys(b).sort();
    if (ka.join() !== kb.join()) return false;
    return ka.every(function (k) { return a[k].slice().sort().join('|') === b[k].slice().sort().join('|'); });
  }

  function matches(li, st) {
    return Object.keys(st).every(function (k) {
      var have = (li.getAttribute('data-f-' + k) || '').split('|');
      return st[k].some(function (v) { return have.indexOf(v) !== -1; });
    });
  }

  function setState(plp, st, history) {
    plp.dvfState = st;
    var shown = 0;
    // The farm story card ([data-dvf-story]) isn't a product: not filtered, not counted.
    plp.querySelectorAll('[data-dvf-grid] > li:not([data-dvf-story])').forEach(function (li) {
      var ok = matches(li, st);
      li.hidden = !ok;
      if (ok) shown++;
    });
    plp.querySelectorAll('[data-dvf-cfilter]').forEach(function (box) {
      box.checked = (st[box.dataset.dvfCfilter] || []).indexOf(box.value) !== -1;
    });
    var tpl = shown === 1 ? plp.dataset.countOne : plp.dataset.countOther;
    if (tpl) setText(plp.querySelector('[data-dvf-count]'), tpl.replace('[count]', shown));
    var empty = plp.querySelector('[data-dvf-cempty]');
    if (empty) empty.hidden = shown > 0;
    var chosen = Object.keys(st).reduce(function (n, k) { return n + st[k].length; }, 0);
    var native = parseInt(plp.dataset.nativeActive || '0', 10);
    var total = chosen + native;
    plp.querySelectorAll('[data-dvf-story]').forEach(function (li) { li.hidden = total > 0; });
    var badge = plp.querySelector('[data-dvf-active-count]');
    if (badge) setText(badge, total ? ' · ' + total : '');
    plp.querySelectorAll('.dvf-facets__clear[data-dvf-clear]').forEach(function (a) { a.hidden = total === 0; });
    plp.querySelectorAll('[data-dvf-chip-query], [data-dvf-chip-all]').forEach(function (chip) {
      var on = chip.hasAttribute('data-dvf-chip-all')
        ? total === 0
        : sameState(stateFromQuery(plp, chip.dataset.dvfChipQuery), st) && native === 0;
      chip.classList.toggle('is-active', on);
      if (on) chip.setAttribute('aria-current', 'page'); else chip.removeAttribute('aria-current');
    });
    if (history) {
      var params = new URLSearchParams(location.search);
      filterKeys(plp).forEach(function (k) { params.delete(k); });
      Object.keys(st).forEach(function (k) { st[k].forEach(function (v) { params.append(k, v); }); });
      var q = params.toString();
      var url = location.pathname + (q ? '?' + q : '') + location.hash;
      if (history === 'push') window.history.pushState({ dvf: 1 }, '', url);
      else window.history.replaceState(window.history.state, '', url);
    }
  }

  function onFilterBox(box) {
    var plp = box.closest('[data-dvf-plp]');
    if (!plp) return;
    var st = {};
    var cur = plp.dvfState || {};
    Object.keys(cur).forEach(function (k) { st[k] = cur[k].slice(); });
    var key = box.dataset.dvfCfilter;
    var vals = Array.prototype.map.call(plp.querySelectorAll('[data-dvf-cfilter="' + key + '"]:checked'), function (b) { return b.value; });
    if (vals.length) st[key] = vals; else delete st[key];
    setState(plp, st, 'replace');
  }

  function initPlp(plp) {
    if (plp.dvfReady) return;
    plp.dvfReady = true;
    setState(plp, stateFromQuery(plp, location.search), false);
  }

  window.addEventListener('popstate', function () {
    document.querySelectorAll('[data-dvf-plp]').forEach(function (plp) { setState(plp, stateFromQuery(plp, location.search), false); });
  });

  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-dvf-chip-query], [data-dvf-chip-all], [data-dvf-clear], [data-dvf-show-results]');
    if (!el) return;
    var plp = el.closest('[data-dvf-plp]');
    if (!plp || !plp.dvfReady) return;
    var native = parseInt(plp.dataset.nativeActive || '0', 10);
    if (el.hasAttribute('data-dvf-chip-query')) {
      if (native) return; // Shopify filters are on: let the link reload the page with them cleared
      e.preventDefault();
      setState(plp, stateFromQuery(plp, el.dataset.dvfChipQuery), 'push');
    } else if (el.hasAttribute('data-dvf-chip-all') || el.hasAttribute('data-dvf-clear')) {
      if (native) return;
      e.preventDefault();
      setState(plp, {}, 'push');
    } else if (el.getAttribute('type') === 'button') {
      // Phones, design filters only: close the panel and show the results.
      e.preventDefault();
      var toggle = plp.querySelector('[data-dvf-filter-toggle]');
      if (toggle && toggle.getAttribute('aria-expanded') === 'true') toggle.click();
      var grid = plp.querySelector('[data-dvf-plp-bar]');
      if (grid && grid.scrollIntoView) grid.scrollIntoView({ block: 'start' });
    }
  });

  // ------------------------------------------------------------------ collection filters + sort

  function formOf(el) {
    return el.form || (el.getAttribute('form') && document.getElementById(el.getAttribute('form')));
  }

  function submit(form) {
    if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
  }

  function onAutoSubmit(el) {
    var form = formOf(el);
    if (!form) return;
    // Sort always applies at once. Filters apply at once on desktop; on phones the panel's
    // "View results" button applies them, so several can be ticked in one go.
    if (el.name === 'sort_by' || isDesktop()) submit(form);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-dvf-facets]')) return;
    // Keep URLs clean: no "filter.v.price.gte=&filter.v.price.lte=".
    form.querySelectorAll('input[type="number"]').forEach(function (i) { if (i.value === '') i.disabled = true; });
    // Carry the design filters (not form fields) through a sort / Shopify-filter reload.
    var plp = form.closest('[data-dvf-plp]');
    var st = (plp && plp.dvfState) || {};
    form.querySelectorAll('input[data-dvf-carry]').forEach(function (i) { i.remove(); });
    Object.keys(st).forEach(function (k) {
      st[k].forEach(function (v) {
        var i = document.createElement('input');
        i.type = 'hidden'; i.name = k; i.value = v; i.setAttribute('data-dvf-carry', '');
        form.appendChild(i);
      });
    });
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-dvf-filter-toggle]');
    if (!btn) return;
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    var open = !panel.classList.contains('is-open');
    panel.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', String(open));
    if (open) {
      var first = panel.querySelector('input, select, button');
      if (first) first.focus({ preventScroll: true });
      panel.scrollIntoView({ block: 'start' }); // CSS scroll-margin keeps it clear of the pinned header + bar
    }
  });

  function init() {
    document.querySelectorAll('[data-dvf-plp]').forEach(initPlp);
    // "Open on desktop" panels (collection comparison): open wide screens, leave phones folded.
    if (isDesktop()) document.querySelectorAll('details[data-dvf-open-desktop]').forEach(function (d) { d.open = true; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);

  window.DVFPlp = { onAutoSubmit: onAutoSubmit, initPlp: initPlp, setState: setState, stateFromQuery: stateFromQuery };
})();
